// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Returns category descriptions selected by `control` in item or native option order, including nested items. */
export function selectedCategoryDescriptions(control) {
  if (control instanceof HTMLSelectElement) {
    return Array.from(control.selectedOptions, (option) => option.dataset.categoryDescription || "");
  }

  const values = [].concat(control.value || []).map(String);

  return descriptionsFor(control.items || [], values);
}

function descriptionsFor(items, values) {
  return items.flatMap(function itemDescriptions(item) {
    const description = values.includes(String(item.value)) ? [item.dataset?.categoryDescription || ""] : [];

    return description.concat(descriptionsFor(item.children || [], values));
  });
}
